const state = {
  // 其他app相关状态可以在这里添加
}

const mutations = {
  // 其他app相关mutations可以在这里添加
}

const actions = {
  // 其他app相关actions可以在这里添加
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js